module.exports = __webpack_public_path__ + "media/src/images/icons/plus-circle-0f8a44cb23aae9259dbd8e00ecae548a.svg";